module.exports = __webpack_public_path__ + "static/creator-tokens-stable-income-3dc36627d4ccfd01022a2d59f9c4b4f2.webp";